import { render, staticRenderFns } from "./VpdIconX.vue?vue&type=template&id=e7a612f8"
import script from "./VpdIconX.vue?vue&type=script&lang=js"
export * from "./VpdIconX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports